import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {MembersNoticeMngDeviceListPage} from "./List";


export const MembersNoticeMngDevicePage: FC = () => {
  return (
      <Routes>
        <Route index element={<MembersNoticeMngDeviceListPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


